export enum GameStatus {
  CREATED='CREATED',
  PENDING='PENDING',
  OPENED='OPENED',
  CLOSED='CLOSED',
  RESULT_PROCESSING='RESULT_PROCESSING',
  COMPLETED='COMPLETED'
}
